(function ($)
{
    let cPhotoGalleryCardsObjectCounter = 0;

    $.widget("ui.PhotoGalleryCards",
        {
            _MyObjectNumber: null,
            _ContentBlockId: null,
            _ContentBlockSource: null,
            _PhotoGalleryId: null,

            options:
            {
                ResultSelector: '.fbcms_card',
                ResultListSelector: '.fbcms_cards',
                GallerySelector: '.fbcms_pgc_gallery',
                MoreSelector: '.fbcms_cards',
                MasonrySelector: '.fbcms_cards.masonry',
                SkiplinksContainerSelector: '.fbcms_card_skiplinks',
                SkiplinkSelector: '.skiplink'
            },

            _destroy: function ()
            {
            },

            _init: function ()
            {
            },

            _create: function ()
            {
                const self = this;
                const jElement = $(self.element);

                const jContentIdContainer = jElement.find('[data-fbpgc-cbid],[data-fbpgc-cbsrc],[data-fbpgc-glid]');
                if (jContentIdContainer.length !== 1)
                {
                    return;
                }

                self._ContentBlockId = jContentIdContainer.data('fbpgc-cbid');
                if (FBUtilities.IsParameterUndefinedOrEmpty(self._ContentBlockId))
                {
                    console.debug("missing content block id");
                    return;
                }

                self._ContentBlockSource = jContentIdContainer.data('fbpgc-cbsrc');
                if (FBUtilities.IsParameterUndefinedOrEmpty(self._ContentBlockSource))
                {
                    console.debug("missing content block source");
                    return;
                }

                self._PhotoGalleryId = jContentIdContainer.data('fbpgc-pgid');
                if (FBUtilities.IsParameterUndefinedOrEmpty(self._PhotoGalleryId))
                {
                    console.debug("missing photogallery id");
                    return;
                }


                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.GallerySelector))
                {
                    FBUtilities.LogMessage('PhotoGalleryCards - required settings null or empty.');
                    return;
                }

                self._MyObjectNumber = cPhotoGalleryCardsObjectCounter++;

                const resultListId = 'PGCResult' + self._MyObjectNumber;

                const jListContainer = jElement.find(self.options.ResultListSelector);
                jListContainer.attr('role', 'region');
                jListContainer.attr('aria-live', 'polite');
                jListContainer.attr('id', resultListId);

                self._InitMasonry();
                /*if (lListContainer.find('[data-lightbox]').length > 0)
                {
                    FBLightbox.Init();
                }*/
                self.SetupCardButtons();

                self.SetupPagination();
            },

            SetupPagination: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const resultListId = 'PGCResult' + self._MyObjectNumber;
                const jGalleryContainer = jElement.find(self.options.GallerySelector);
                const jMoreContainer = jGalleryContainer.find(self.options.MoreSelector);

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: "/Core/Gallery/Cards/",
                        LoadingTitle: "Cards",
                        NormalContainer: jGalleryContainer,
                        MoreContainer: jMoreContainer,
                        RequestDataFunc: function ()
                        {
                            return {
                                contentBlockId: self._ContentBlockId,
                                contentBlockSource: self._ContentBlockSource,
                                photoGalleryId: self._PhotoGalleryId
                            };
                        },
                        OnSuccess: function (mode, data, textStatus, jqXHR)
                        {
                            self._InitMasonry();
                            self.SetupCardButtons();
                        },
                        LiveRegionId: resultListId
                    });

            },

            _InitMasonry: function ()
            {
                const self = this;
                const jElement = $(self.element);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.MasonrySelector))
                {
                    return;
                }

                const jContainer = jElement.find(self.options.MasonrySelector);

                if (jContainer.length === 1)
                {
                    jContainer.imagesLoaded(function ()
                    {
                        // init Masonry after all images have loaded
                        jContainer.masonry(
                            {
                                // options
                                itemSelector: self.options.ResultSelector,
                                columnWidth: self.options.ResultSelector
                            });
                    });
                }
            },

            SetupCardButtons: function ()
            {
                const self = this;
                const jElement = $(self.element);
                const jContainer = jElement.find(self.options.ResultListSelector);
                const jCards = jContainer.find(self.options.ResultSelector);

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.SkiplinksContainerSelector) === false
                    && FBUtilities.IsStringEmptyOrWhitespace(self.options.SkiplinkSelector) === false)
                {
                    $.each(
                        jCards,
                        function (aIndex, aValue)
                        {
                            const jCard = $(aValue);
                            jCard.find(self.options.SkiplinksContainerSelector).DropFocusManager(
                                {
                                    TitleOpenerSelector: self.options.SkiplinkSelector
                                    , DropLinksSelector: self.options.SkiplinkSelector
                                }
                            );
                        }
                    );
                }
            }
        });

    FBUtilities.initPhotoGalleryCards = function (aElement, aOnInitializedCallback)
    {
        if ($(aElement).PhotoGalleryCards("instance") !== undefined)
        {
            $(aElement).PhotoGalleryCards("destroy");
        }

        $(aElement).PhotoGalleryCards();

        aOnInitializedCallback(aElement);
    };

})(jQuery);

